import { ChangeEvent, memo, SyntheticEvent } from 'react';
import CloseIcon from '@stripcash/ui-kit/icons/close.svg';
import Button, { ButtonColor } from '@stripcash/ui-kit/components/Button';
import ButtonIcon, {
  ButtonIconStyle,
} from '@stripcash/ui-kit/components/ButtonIcon';

import { Translate } from 'common/i18n/types';

import style from './style.module.css';

type PropsType = {
  onMessageSend: (event: SyntheticEvent) => void;
  isLoading: boolean;
  onMessageChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  onClose: () => void;
  message: string;
  t: Translate;
};
const ModalWithMessage = memo(
  ({
    onMessageSend,
    isLoading,
    onMessageChange,
    onClose,
    message,
    t,
  }: PropsType) => (
    <div className={style.contactUsModal}>
      <h2 className={style.contactUsModalHeader}>
        {t('contactUs.defaultSubtitle')}
      </h2>
      <p className={style.contactUsModalDescription}>
        {t('contactUs.defaultText')}
      </p>
      <form className={style.contactUsForm} onSubmit={onMessageSend}>
        <textarea
          disabled={isLoading}
          onChange={onMessageChange}
          className={style.contactUsTextArea}
          name="messageReport"
          id="message"
          data-testid="message"
          rows={4}
          maxLength={1000}
          value={message}
        />
        <div className={style.contactUsSubmitWrapper}>
          <Button
            color={ButtonColor.Blue}
            disabled={isLoading || !message.trim().length}
            type="submit"
            data-testid="contactUsSubmit"
          >
            {t('contactUs.submit')}
          </Button>
        </div>
      </form>
      <div className={style.contactUsCloseBtn}>
        <ButtonIcon
          style={ButtonIconStyle.SmallColored}
          disabled={isLoading}
          onClick={onClose}
        >
          <CloseIcon size={12} />
        </ButtonIcon>
      </div>
    </div>
  ),
);

export default ModalWithMessage;
